// import React, { Component } from 'react'

import { Stack, alert } from '@pnotify/core';
import '@pnotify/core/dist/PNotify.css';
// import "@pnotify/core/dist/BrightTheme.css";
import * as Confirm from '@pnotify/confirm';
import '@pnotify/confirm/dist/PNotifyConfirm.css';

var defaultStack = new Stack({
  dir1: 'down',
  dir2: 'left',
  firstpos1: 25,
  firstpos2: 25,
  spacing1: 36,
  spacing2: 36,
  push: 'bottom',
  maxOpen: 4,
  maxStrategy: 'close', //wait
  context: document.body,
  modal: false, //ish
});

export const notificationsReadToggle = () => {
  alert({
    title: 'Notify has been toggled',
    // text: "You have clicked the button. You may now complete the process of reading the notice.",
    stack: defaultStack,
    addClass: 'custom-notify',
    icon: false,
    closerHover: false,
    sticker: false,
    stickerHover: false,
    styling: '',
    // modules: new Map([
    //   [
    //     Confirm,
    //     {
    //       confirm: true,
    //       buttons: [
    //         {
    //           text: "Ok",
    //           primary: true,
    //           click: notice => {
    //             notice.close();
    //           }
    //         }
    //       ]
    //     }
    //   ]
    // ])
  });
}

export const notifyUser = (title: string, text: string, delay?: number, onClick?: ()=>void) =>{
    const a = alert({
      title,
      text,
      stack: defaultStack,
      addClass: 'custom-notify',
      icon: false,
      closerHover: false,
      sticker: false,
      stickerHover: false,
      styling: '',
      delay: delay,
    });

    if (onClick) {
      a.on('click', e => {
        if ([...a.refs.elem.querySelectorAll('.pnotify-closer *, .pnotify-sticker *')].indexOf(e.target) !== -1) {
          return;
        }

        onClick();
        a.close(true);
      });
    }
}

export const getConfirmationUser = (title: string) => {
  alert({
    title,
    stack: defaultStack,
    addClass: 'custom-notify',
    icon: false,
    closerHover: false,
    sticker: false,
    stickerHover: false,
    modules: new Map([
      [
        Confirm,
        {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              primary: true,
              click: notice => {
                notice.close();
              },
            },
            {
              text: 'Cancel',
              primary: false,
              click: notice => {
                notice.close();
              },
            },
          ],
        },
      ],
    ]),
  });
}
